import { useState } from "react";
import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import { ReactComponent as PlusPrimary } from "../../assets/icons/primary_plus.svg"
import CreateEntryModal from "./CreateEntryModal";


const InterCompanyEliminationsEntries = ({ setEliminationScreen }) => {

    const entriesData = [
        {
            particulars: "Revenue from Operations",
            date: "31-03-2025",
            currentYear: "12,50,000",
            previousYear: "10,80,000",
            remarks: "10% increase due to higher sales volume",
        },
        {
            particulars: "Other Income",
            date: "31-03-2025",
            currentYear: "1,20,000",
            previousYear: "1,00,000",
            remarks: "Includes dividend income from subsidiary",
        },
        {
            particulars: "Cost of Goods Sold",
            date: "31-03-2025",
            currentYear: "7,30,000",
            previousYear: "6,50,000",
            remarks: "Increased raw material cost",
        },
        {
            particulars: "Employee Benefit Expenses",
            date: "31-03-2025",
            currentYear: "2,40,000",
            previousYear: "2,10,000",
            remarks: "New hires for expansion project",
        },
        {
            particulars: "Depreciation & Amortisation",
            date: "31-03-2025",
            currentYear: "80,000",
            previousYear: "75,000",
            remarks: "Additional assets capitalized this year",
        },
        {
            particulars: "Finance Costs",
            date: "31-03-2025",
            currentYear: "50,000",
            previousYear: "60,000",
            remarks: "Loan repayment reduced interest cost",
        },
        {
            particulars: "Profit Before Tax",
            date: "31-03-2025",
            currentYear: "3,70,000",
            previousYear: "3,05,000",
            remarks: "Improved operational efficiency",
        },
        {
            particulars: "Tax Expense",
            date: "31-03-2025",
            currentYear: "90,000",
            previousYear: "80,000",
            remarks: "Reflects higher taxable income",
        },
        {
            particulars: "Net Profit After Tax",
            date: "31-03-2025",
            currentYear: "2,80,000",
            previousYear: "2,25,000",
            remarks: "Overall growth of 24%",
        },
    ];

    const [ entryModal, setEntryModal ] = useState(false)


    const closeEntryModal = () => {
        setEntryModal(false)
    }

    return (
        <>
            <div className={icrCss.header} style={{ justifyContent: "end" }}>
                <Button
                    btnColor={buttoncss.greyBg}
                    label="View Workings"
                    onClick={()=> setEliminationScreen(1)}
                />
                <Button
                    icon={<PlusPrimary />}
                    btnColor={buttoncss.greyBg}
                    label="Add Entry"
                    onClick={()=> setEntryModal(true)}
                />
                <Button
                    btnColor={buttoncss.primary}
                    label="Populate FS"
                />
            </div>
            <div className={icrCss.entrytableCtn}>
                <table className={icrCss.entrytable}>
                    <thead>
                        <th style={{ textAlign:"left" }}>Particulars</th>
                        <th>Date</th>
                        <th>Current year</th>
                        <th>Previous year</th>
                        <th style={{ textAlign:"left" }}>Remarks</th>
                    </thead>
                    <tbody>
                        {entriesData.map((item, index) => (
                        <tr key={index}>
                            <td style={{ textAlign:"left" }}>{item.particulars}</td>
                            <td>{item.date}</td>
                            <td>{item.currentYear}</td>
                            <td>{item.previousYear}</td>
                            <td style={{ textAlign:"left" }}>{item.remarks}</td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {entryModal && (
                <CreateEntryModal 
                    handleClose={closeEntryModal}
                />
            )}
        </>
    )

}

export default InterCompanyEliminationsEntries;